import { useEffect } from "react"
import {
  BottomNavigation as MuiBottomNavigation,
  BottomNavigationAction,
  Box,
  useTheme,
} from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import qs from "qs"
import { useTranslation } from "providers/i18n"

import { useAppUI } from "providers/ui"
import { MoreIcon } from "components/icons"
import { Sidebar } from "../Sidebar/Sidebar"

export const MobileNavigation = ({
  value,
  bottomNavigations = [],
  navigations = [],
}) => {
  const location = useLocation()
  const { sidebarState, setSidebarState } = useAppUI()

  const { t } = useTranslation()

  const theme = useTheme()
  const styleOverrides =
    theme.components[`AppMobileNavigation`]?.styleOverrides || {}
  const { root, menuButton, moreButton } = styleOverrides

  // Close Drawer when url changed
  useEffect(() => {
    setSidebarState(false)
  }, [location.pathname, setSidebarState])

  return (
    <>
      <Box sx={root}>
        <MuiBottomNavigation value={value} showLabels>
          {bottomNavigations.map((nav) => (
            <BottomNavigationAction
              sx={menuButton}
              component={Link}
              key={nav.to}
              label={t([`navigation.${nav.label}`, nav.label])}
              to={`${nav.to}?${qs.stringify(nav.qs)}`}
              value={nav.value || nav.to}
              icon={nav.icon}
            />
          ))}
          <BottomNavigationAction
            sx={moreButton}
            label={t("navigation.More")}
            onClick={() => setSidebarState(true)}
            icon={<MoreIcon />}
          />
        </MuiBottomNavigation>
      </Box>

      <Sidebar
        open={sidebarState}
        onClose={() => setSidebarState(false)}
        anchor="left"
        navigations={navigations}
      />
    </>
  )
}
